var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUseIsdoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_sub_dot",
    cx: 21.347,
    cy: 21.319,
    r: 1.445
  }), /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_sub_dot",
    cx: 17.132,
    cy: 25.534,
    r: 1.445
  }), /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 25.617,
    cy: 17.159,
    r: 1.445
  }), /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M21.924 30.641c5.331 3.315 10.322 4.123 11.412 3.033 1.098-1.098.03-6.531-3.029-11.752M20.797 12.422C15.932 9.5 10.581 7.921 9.119 9.382c-1.338 1.338-.299 6.436 3.091 11.689"
  }), /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M26.233 26.055c5.261-5.261 9.239-15.042 7.18-17.101-1.783-1.783-10.252.657-16.859 7.264-6.923 6.923-8.903 15.484-7.434 16.953 1.495 1.495 11.021-1.023 17.113-7.116z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseIsdoc);
export default __webpack_public_path__ + "static/media/use_isdoc.10dc6380d1f1eb6916cd4ed2f7479752.svg";
export { ForwardRef as ReactComponent };